function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53.15 34.597a5.982 5.982 0 1 1 0-11.953 5.976 5.976 0 0 1 0 11.953zm0-11.01a5.041 5.041 0 1 0 5.053 5.027 4.97 4.97 0 0 0-1.492-3.56 4.92 4.92 0 0 0-3.548-1.467h-.013z",
  fill: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M53.15 31.498a2.894 2.894 0 1 1 0-5.789 2.894 2.894 0 0 1 0 5.789zm0-4.831a1.95 1.95 0 1 0 .002 3.898 1.95 1.95 0 0 0-.002-3.897v-.001zM14.15 35.597a5.982 5.982 0 1 1 0-11.953 5.976 5.976 0 0 1 0 11.953zm0-11.01a5.041 5.041 0 1 0 5.053 5.027 4.97 4.97 0 0 0-1.492-3.56 4.92 4.92 0 0 0-3.548-1.467h-.013z",
  fill: "#E4ECFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.15 32.498a2.894 2.894 0 1 1 0-5.789 2.894 2.894 0 0 1 0 5.789zm0-4.831a1.95 1.95 0 1 0 .002 3.898 1.95 1.95 0 0 0-.002-3.897v-.001zM63.898 29.365h-3.927l.131-.563c.061-.288.092-.582.092-.877a5.484 5.484 0 0 0-.118-1.074l-.118-.563h3.927l.013 3.077zm-2.815-.943h1.846v-1.19h-1.885c.013.23.013.462 0 .693.053.161.066.333.039.5v-.003zM46.564 29.365H43.37v-3.077h3.26l-.1.563a5.894 5.894 0 0 0-.092 1.074c.002.306.024.613.065.916l.061.524zm-2.252-.943H45.5v-1.19h-1.2l.012 1.19z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M43.71 29.953H20.381v-1.06c0-.298-.027-.596-.079-.89l-.092-.55h23.434l.066 2.5zm-22.321-.943h21.379v-.615h-21.4v.5l.02.115z",
  fill: "#E4ECFF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M43.711 27.937H20.395l-.079-.367a6.206 6.206 0 0 0-11.939-.668l-.065.157-.524.314H1.7v-6H0V0h43.294v5.237h.445l-.028 22.7zm-22.57-.943h21.627V6.179h-.445V.943H.941v19.52h1.767v6.035h4.9a7.148 7.148 0 0 1 13.6.563l-.067-.067z",
  fill: "#E4ECFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.539 29.391H1.11v-2.5h7.03l-.08.55a5.077 5.077 0 0 0-.078.89v1.021l-.444.04zm-5.485-.943h4.988v-.615H2.054v.615zM63.702 26.642h-4.085l-.092-.353a6.639 6.639 0 0 0-12.882 0l-.092.353h-3.26V5.21h15.8l4.582 10.12.029 11.31zm-3.365-.943h2.422V15.436l-4.242-9.282H44.261v19.545h1.571a7.58 7.58 0 0 1 14.505 0zm1.61-9.308h-6.545l-4.294-3.6h-6.1V6.756h13.419l3.52 9.635zm-6.245-.943h4.88l-2.893-7.75H45.91v4.15h5.512l4.28 3.6z",
  fill: "#E4ECFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M49.642 14.008h-3.81v1.414h3.81v-1.414zM44.103 20.632H1.726v.943h42.377v-.943z",
  fill: "#E4ECFF"
});

var SvgBoxTruck = function SvgBoxTruck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 36,
    viewBox: "0 0 64 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoxTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boxTruck.16c9d480.svg";
export { ForwardRef as ReactComponent };